import { render } from "./ViewSempro.vue?vue&type=template&id=6a711381"
import script from "./ViewSempro.vue?vue&type=script&lang=js"
export * from "./ViewSempro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__